export default "__VITE_ASSET__Bg19m0ZM__"